import { render, staticRenderFns } from "./ShareGauge.vue?vue&type=template&id=4c1bb516&lang=pug&"
import script from "./ShareGauge.vue?vue&type=script&lang=js&"
export * from "./ShareGauge.vue?vue&type=script&lang=js&"
import style0 from "./ShareGauge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports